export enum MapAreaSelectionMode {
  Markers = 'markers',
  BoxSelector = 'box-selector',
}
